import React, { useEffect, useState } from "react";
import DataTableLayer from "../../components/DataTableLayer";
import { Icon } from "@iconify/react";
import PostByAgg from "../../utils/axios";
import LottieLoading from "../../components/child/LottieLoading";
import ModalAlert from "../../components/ModalAlert";

const ListAllSongs = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(null);
    const [listSongs, setListSongs] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0,
    });

    const columns = [
        // {
        //     header: "Song Code",
        //     accessorKey: "song_code",
        // },
        {
            header: "Title",
            accessorKey: "title",
        },
        {
            header: "Sub Title",
            accessorKey: "sub_title",
        },
        {
            header: "Artists",
            accessorKey: "artists",
        },
        {
            header: "Genre",
            accessorKey: "sub_genre_name",
        },
        {
            header: "Production Year",
            accessorKey: "production_year",
        },
        // {
        //     header: "ISRC",
        //     accessorKey: "isrc",
        // },
        {
            header: "Channels",
            accessorKey: "channels",
        },
        // {
        //     header: "Parental Guidance",
        //     accessorKey: "parental_guidance_name",
        // }
    ];

    const getAllSongs = () => {
        setIsLoading(true);
        const url = 'song/v1/track/list-all';
        PostByAgg({
            url: url,
            body: {
                "page": pagination.pageIndex + 1,
                "page_size": 1000, // Fetching a large batch as per Catalogue pattern
            },
            onResponse: (response) => {
                setIsLoading(false);
                if (response.data.code === "2002000") {
                    const data = response.data.data;
                    setListSongs(data.data || []);
                    setPagination((prev) => ({
                        ...prev,
                        totalRecords: data.total_records,
                        totalPages: data.total_pages,
                    }));
                } else {
                    setListSongs([]);
                }
            },
            onError: (error) => {
                setIsLoading(false);
                console.error("Error Fetching All Songs: ", error);
                setModalOpen(
                    <ModalAlert
                        show={true}
                        type={"failed"}
                        text={error.response?.data?.message?.en || "Failed to fetch songs"}
                        action={() => setModalOpen(null)}
                    />
                );
            }
        });
    };

    useEffect(() => {
        getAllSongs();
    }, []);

    return (
        <div>
            <DataTableLayer
                data={listSongs}
                columns={columns}
                title={"List All Songs"}
                pagination={pagination}
                showButton={false}
            />
            {isLoading && <LottieLoading text="Loading..." />}
            {modalOpen}
        </div>
    );
};

export default ListAllSongs;
